(() => {
  const initializeCartSupport = (root = document) => {
    root.querySelectorAll('[data-lv-cart-support]').forEach((support) => {
      if (support.dataset.lvCartSupportReady === 'true') return;

      const dialog = support.querySelector('[data-lv-cart-support-dialog]');
      const openButton = support.querySelector('[data-lv-cart-support-open]');
      const closeButton = support.querySelector('[data-lv-cart-support-close]');

      if (!dialog || !openButton) return;
      support.dataset.lvCartSupportReady = 'true';

      const openDialog = () => {
        if (typeof dialog.showModal === 'function') {
          if (!dialog.open) dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      };

      const closeDialog = () => {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      };

      openButton.addEventListener('click', openDialog);
      closeButton?.addEventListener('click', closeDialog);

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });

      if (dialog.querySelector('[data-lv-cart-support-feedback]')) {
        openDialog();
      }
    });
  };

  initializeCartSupport();
  document.addEventListener('shopify:section:load', (event) => initializeCartSupport(event.target));
})();
